export const TIMEOUT_TIME = 4 * 60 * 60 * 1000; // 4 hours in milis = 14.400.000 milis
